import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useSyncExternalStore } from "react";
import { getConsent, subscribeConsent, setConsent } from "@/lib/consent";

export function ConsentBanner() {
  const consent = useSyncExternalStore(subscribeConsent, getConsent);
  const visible = !consent;

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ y: 140, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 140, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-0 bottom-0 z-[80] px-4 pb-4"
          data-testid="consent-banner"
        >
          <div className="mx-auto flex max-w-4xl flex-col gap-4 rounded-lg border border-border bg-card p-5 shadow-offset sm:flex-row sm:items-center sm:gap-6 sm:p-6">
            <Cookie className="hidden h-7 w-7 shrink-0 text-primary sm:block" />
            <div className="flex-1">
              <p className="font-serif text-lg leading-snug">Tu privacidad, en dos líneas</p>
              <p className="mt-1 text-sm leading-relaxed text-muted-foreground">
                Usamos cookies publicitarias de Google AdSense para mantener
                Curiosímetro gratis. Puedes aceptarlas todas o rechazarlas; guardamos
                tu elección en tu navegador y registramos la decisión de forma anónima.
              </p>
            </div>
            <div className="flex shrink-0 flex-wrap gap-2">
              <button
                onClick={() => setConsent("rejected")}
                data-testid="consent-reject-button"
                className="rounded-full border border-border px-4 py-2 text-sm font-medium transition-colors hover:border-primary hover:text-primary"
              >
                Rechazar
              </button>
              <button
                onClick={() => setConsent("accepted")}
                data-testid="consent-accept-button"
                className="rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-all hover:shadow-offset-accent"
              >
                Aceptar todas
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
